/**
 * Copyright (c) 2018-2023, BOTLabs GmbH.
 *
 * This source code is licensed under the BSD 4-Clause "Original" license
 * found in the LICENSE file in the root directory of this source tree.
 */
/**
 * DID keys are purpose-bound. Their role or purpose is indicated by the verification or key relationship type.
 */
const keyRelationshipsC = [
    'authentication',
    'capabilityDelegation',
    'assertionMethod',
    'keyAgreement',
];
export const keyRelationships = keyRelationshipsC;
/**
 * Possible types for a DID verification key.
 */
const verificationKeyTypesC = ['sr25519', 'ed25519', 'ecdsa'];
export const verificationKeyTypes = verificationKeyTypesC;
/**
 * Possible types for a DID encryption key.
 */
const encryptionKeyTypesC = ['x25519'];
export const encryptionKeyTypes = encryptionKeyTypesC;
